"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.incrementMinutes = void 0;
var utils_1 = require("@time-input-polyfill/utils");
function incrementMinutes(utils) {
    var a11yHasExpectedHtml = utils.a11yHasExpectedHtml, hasReturnVal = utils.hasReturnVal, loadPrimaryInput = utils.loadPrimaryInput, setTime = utils.setTime, use = utils.use;
    describe('Minutes - Increment', function () {
        it('Should increment as expected on up key press', function () {
            loadPrimaryInput({ segment: 'minutes' }).then(function () {
                setTime('12:59 AM', 'minutes').then(function () {
                    var a = 0;
                    while (a < 60) {
                        use.upArrow()
                            .should('have.value', "12:".concat((0, utils_1.toLeadingZero)(a), " AM"))
                            .then(a11yHasExpectedHtml("<p>".concat(a, ".</p>")))
                            .then(hasReturnVal("00:".concat((0, utils_1.toLeadingZero)(a))));
                        a++;
                    }
                    // Testing that it loops back around at the end
                    use.upArrow()
                        .should('have.value', "12:00 AM")
                        .then(a11yHasExpectedHtml("<p>0.</p>"))
                        .then(hasReturnVal("00:00"));
                });
            });
        });
    });
}
exports.incrementMinutes = incrementMinutes;
